import { Dashboard } from '@/common/dashboard/Dashboard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { DropdownSelect } from '@/common/form/formFields/DropdownSelect';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';
import { PeriodSelect } from '../../common/PeriodSelect';
import { InctvRbtProgressChart } from './charts/InctvRbtProgressChart';
import { InctvRbtUnpaidCard } from './InctvRbtUnpaidCard';
import { InctvTrendCard } from './InctvTrendCard';

const METRICS = [
  { value: 'RBT_AMT', displayName: 'Rebate Amount' },
  { value: 'SALES_AMT', displayName: 'Sales Amount' },
  { value: 'QTY', displayName: 'Quantity' },
];

// All Entity Filter Field Definitions
const entityFilterFieldDefs = [
  {
    field: 'prodExpr',
    displayName: 'Products',
    entity: 'PROD',
    code: 'PROD',
    module: 'md',
    multiple: true,
    parentFilterEntityModule: 'sc',
    parentFilterEntity: 'INCTV_RBT_LINE',
    parentFilterFkField: 'prodId',
  },
  {
    field: 'custExpr',
    displayName: 'Customers',
    entity: 'CUST',
    code: 'CUST',
    module: 'md',
    multiple: true,
    parentFilterEntityModule: 'sc',
    parentFilterEntity: 'INCTV_RBT',
    parentFilterFkField: 'custId',
  },
  {
    field: 'ctrtExpr',
    displayName: 'Contracts',
    entity: 'CTRT',
    code: 'CTRT',
    module: 'md',
    multiple: true,
    parentFilterEntityModule: 'sc',
    parentFilterEntity: 'INCTV_RBT_LINE',
    parentFilterFkField: 'ctrtId',
  },
];

export const InctvRbtDashboard = () => {
  const rsrc = useRsrc();

  const defaultFormValues = useRef();
  const [periodicityToPeriods, setPeriodicityToPeriods] = useState();

  useEffect(() => {
    rsrc.data('sc', 'INCTV_DASHBOARD_FILTERS_DATA_PLUGIN', {}).then((res) => {
      defaultFormValues.current = {
        periodicity: 'QTR',
        startPeriodId: res.defaultStartPeriodId,
        endPeriodId: res.defaultEndPeriodId,
        metric: METRICS[0].value,
        prodExpr: null,
        custExpr: null,
        ctrtExpr: null,
      };
      setPeriodicityToPeriods(res.periodicityToPeriods);
    });
  }, []);

  if (!periodicityToPeriods) {
    return null;
  }

  return (
    <Dashboard
      title="Incentive Rebate Dashboard"
      titleIcon={fas.faChartBar}
      module="sc"
      defaultFormValues={defaultFormValues.current}
    >
      <FilterContainer>
        <DropdownSelect
          fieldDef={{
            field: 'periodicity',
            displayName: 'Periodicity',
            values: [
              { value: 'MON', displayName: 'Month' },
              { value: 'QTR', displayName: 'Quarter' },
              { value: 'YEAR', displayName: 'Year' },
            ],
          }}
        />
        <PeriodSelect
          fieldDef={{ field: 'startPeriodId', displayName: 'Start Period' }}
          periodicityToPeriods={periodicityToPeriods}
        />
        <PeriodSelect
          fieldDef={{ field: 'endPeriodId', displayName: 'End Period' }}
          periodicityToPeriods={periodicityToPeriods}
        />
        <DropdownSelect fieldDef={{ field: 'metric', displayName: 'Metric', values: METRICS }} />
        {entityFilterFieldDefs.map((fieldDef) => (
          <EntitySelect key={fieldDef.field} fieldDef={{ ...fieldDef, variant: 'outlined' }} />
        ))}
      </FilterContainer>
      <SpacerLayout>
        <Spacer vertical>
          <Spacer weights={[1, 2.5]}>
            <InctvRbtProgressChart />
            <InctvRbtUnpaidCard />
          </Spacer>
          <Spacer>
            <InctvTrendCard source="RBT" />
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </Dashboard>
  );
};
